import { Stack } from '@/components/layout';
import { useScaling } from '@/hooks/use-scaling';
import { colors, ColorToken, withOpacity } from '@/theme/colors';
import { memo, useMemo } from 'react';
import { ViewStyle } from 'react-native';

export const ContentWrapper = memo(
  ({
    children,
    level,
    outerStyle,
  }: {
    children: React.ReactNode;
    level: number;
    outerStyle?: ViewStyle;
  }) => {
    const { scale } = useScaling();
    const borderStyle = useMemo(
      () => ({
        borderLeftWidth: scale(9),
        borderLeftColor: withOpacity(colors[`Level ${level}` as ColorToken], 0.2),
      }),
      [scale, level],
    );
    return (
      <Stack backgroundColor="white" overflow="hidden" style={[borderStyle, outerStyle]}>
        <Stack
          justify="center"
          align="center"
          backgroundColor={'white'}
          overflow="hidden"
          gap={scale(8)}
          direction="row">
          {children}
        </Stack>
      </Stack>
    );
  },
);
